export default __webpack_public_path__ + "static/media/Create-documentation.ab5d1999.md";